export default __webpack_public_path__ + "0e87c0ffc34d6318b553a61ed017edaf.png";